module.exports = __webpack_public_path__ + "img/athlete-platzhalter.214c9192.jpg";